import React, { useContext } from 'react';
import { getContext } from 'common';
import { ListContext } from './List';
import { ListItemBasicContext } from './ListItemBasic';
import { ListItemCheckedContext } from './ListItemChecked';
import { ListItemCascadingContext } from './ListItemCascading';

import Styled from './styles';

export interface ListItemIconProps extends React.ComponentPropsWithRef<'div'> {
  /**  The children. Consider using `Icon` component. */
  children: React.ReactNode;
  /** Display the text as disabled. */
  disabled?: boolean;
  /** @ignore used internally */
  $theme?: any;
}

/** Component to add and style an Icon in a list item. All other props will be provided to the root element. */
const ListItemIcon = React.forwardRef<HTMLElement, ListItemIconProps>((props: ListItemIconProps, ref) => getContext(({ RTL }) => {
  const {
    children,
    disabled,
    ...otherProps
  } = props;
  const listContext = useContext(ListContext);
  const listItemBasicContext = useContext(ListItemBasicContext);
  const listItemCheckedContext = useContext(ListItemCheckedContext);
  const listItemCascadingContext = useContext(ListItemCascadingContext);
  const isDisabled = listItemBasicContext.disabled || listItemCheckedContext.disabled || listItemCascadingContext.disabled || disabled;
  return (
    <Styled.ListItemIcon
      ref={ref}
      RTL={RTL}
      $theme={listContext.theme}
      disabled={isDisabled}
      {...otherProps}
    >
      {children}
    </Styled.ListItemIcon>
  );
}));

ListItemIcon.displayName = 'ListItemIcon';

ListItemIcon.defaultProps = {
  disabled: false,
  $theme: {}
};

export default ListItemIcon;
